// Strings of the expense types and the simple expense form (migration 045, request of 29 Oct 2026, item 7). Arabic
// marked "new" needs review by an Arabic copy editor.
export const EXPENSE_STRINGS: Record<"en" | "ar", Record<string, string>> = {
  en: {
    expenseTypes: "Expense types",
    etIntro: "Expense types are what people choose when they enter an expense (Rent, Electricity, Internet ...). Each type posts to the expense account linked here, so nobody else needs to pick an account. Only the business owner or a user with the advanced accounting right can add or change types. Changing a type never changes expenses already saved.",
    etNew: "New expense type",
    etEdit: "Edit expense type",
    etFormSub: "Name it in both languages and link it to the expense account it posts to.",
    etName: "Expense type",
    etNameEn: "Name in English",
    etNameAr: "Name in Arabic",
    etAccount: "Posts to account",
    etAccountHint: "Only accounts the chart classifies under Expenses.",
    etAccountMoved: "{n} expenses name this type. Saved and posted expenses keep their account; drafts must be opened and saved again before posting.",
    etCostCenter: "Default cost center",
    etCostCenterHint: "Optional. Used when the expense names no cost center.",
    etActive: "Active",
    etInactive: "Inactive",
    etInactiveHint: "An inactive type is not offered for new expenses; existing expenses keep it.",
    etUsed: "Expenses",
    etManageLocked: "Only the business owner or a user with the advanced accounting right (journalEntryAdd) can add or change expense types.",
    etEmpty: "No expense types yet",
    etEmptyBody: "Add the types your team uses (Rent, Electricity ...) and link each to its expense account.",
    etEmptyBodyAsk: "Ask the business owner to add expense types.",
    expSimpleSub: "Choose the expense type, the amount and where it was paid from. Tax only when it applies.",
    expType: "Expense type",
    expTypeNone: "No expense types are set up. Ask the business owner to add them in Settings › Expense types.",
    expTypeNoneAdmin: "No expense types are set up yet: add them in Settings › Expense types, or choose an account under Advanced accounting details.",
    expTypeByAccount: "– account chosen below –",
    expPaidFrom: "Paid from",
    expCashBoxes: "Cash boxes",
    expBanks: "Banks",
    expSplit: "Pay from more than one source",
    expOneSource: "Pay from one source",
    expSplitTotal: "The sources must add up to {x}.",
    expRecYesPlain: "Recoverable (input tax)",
    expTransactionInfo: "Transaction information",
    expDetails: "Expense details",
    expName: "Expense name",
    expNameHint: "Optional. A short name for this expense, such as \"October rent\". The note stays separate.",
    expCcFromType: "Filled from the expense type. Clear it to save without a cost center.",
    expCcOptional: "Optional. Left empty, the expense is saved without a cost center.",
    expAdvanced: "Advanced accounting details",
    etTaxDefault: "Default tax treatment of expenses",
    etTaxDefaultNone: "Not set",
    etTaxDefaultHint: "Used for every expense the accountant does not set otherwise. Changing it does not change expenses already saved.",
    etTaxDefaultUnset: "Not set yet: users cannot save an expense with tax until you choose it. You or the accountant can still set the treatment on each expense.",
    etTaxDefaultSaved: "The default tax treatment was saved.",
    expTaxByDefault: "Tax treatment: {x}, as set for the business.",
    expTaxByDefaultUnset: "The business has not set the default tax treatment of expenses yet. Ask the business owner or the accountant to set it in Settings › Expense types.",
    expTaxKept: "Tax treatment: {x}, as set by the accountant.",
    expRecDefault: "As set for the business ({x})",
    expRecDefaultUnset: "Choose (the business has no default yet)",
    fieldExpTaxDefaultMissing: "The business has not set the default tax treatment of expenses yet. Ask the business owner or the accountant to set it in Settings › Expense types.",
    expTypeAccount: "This type posts to {a}.",
    expAdvancedHint: "Choose an expense type, or an expense account directly.",
    expDirectAccount: "Post to another account",
    expDirectAccountHint: "Leave empty to use the type's account. Choosing an account replaces the type.",
    errExpenseAccountNotAllowed: "Choose an expense type. Choosing the account directly needs the business owner or the advanced accounting right.",
    errExpenseTypeChanged: "This expense's type now posts to another account than when it was saved. Open it, check it and save it again before posting.",
    fieldExpTypeInactive: "This expense type is inactive. Choose another type, or ask the business owner to activate it.",
    fieldExpTypeUnmapped: "This expense type's account is no longer an expense account. Ask the business owner to link the type to an expense account in Settings › Expense types."
  },
  ar: {
    expenseTypes: "أنواع المصروفات", // new
    etIntro: "أنواع المصروفات هي ما يختاره المستخدمون عند إدخال مصروف (إيجار، كهرباء، إنترنت ...). كل نوع يُرحَّل إلى حساب المصروف المرتبط به هنا، فلا يحتاج غيرك إلى اختيار حساب. يضيف الأنواع أو يعدّلها مالك النشاط أو مستخدم لديه صلاحية المحاسبة المتقدمة فقط. تعديل النوع لا يغيّر المصروفات المحفوظة.", // new
    etNew: "نوع مصروف جديد", // new
    etEdit: "تعديل نوع المصروف", // new
    etFormSub: "سمِّه باللغتين واربطه بحساب المصروف الذي يُرحَّل إليه.", // new
    etName: "نوع المصروف", // new
    etNameEn: "الاسم بالإنجليزية", // new
    etNameAr: "الاسم بالعربية", // new
    etAccount: "يُرحَّل إلى حساب", // new
    etAccountHint: "الحسابات المصنفة ضمن المصروفات في دليل الحسابات فقط.", // new
    etAccountMoved: "{n} مصروفات تستخدم هذا النوع. المصروفات المحفوظة والمرحّلة تحتفظ بحسابها؛ المسودات يجب فتحها وحفظها من جديد قبل الترحيل.", // new
    etCostCenter: "مركز التكلفة الافتراضي", // new
    etCostCenterHint: "اختياري. يُستخدم عندما لا يحدد المصروف مركز تكلفة.", // new
    etActive: "نشط", // new
    etInactive: "غير نشط", // new
    etInactiveHint: "النوع غير النشط لا يظهر للمصروفات الجديدة؛ المصروفات الحالية تحتفظ به.", // new
    etUsed: "المصروفات", // new
    etManageLocked: "يضيف أنواع المصروفات أو يعدّلها مالك النشاط أو مستخدم لديه صلاحية المحاسبة المتقدمة (journalEntryAdd) فقط.", // new
    etEmpty: "لا توجد أنواع مصروفات بعد", // new
    etEmptyBody: "أضف الأنواع التي يستخدمها فريقك (إيجار، كهرباء ...) واربط كلًّا منها بحساب المصروف.", // new
    etEmptyBodyAsk: "اطلب من مالك النشاط إضافة أنواع المصروفات.", // new
    expSimpleSub: "اختر نوع المصروف والمبلغ ومصدر الدفع. الضريبة عند الحاجة فقط.", // new
    expType: "نوع المصروف", // new
    expTypeNone: "لا توجد أنواع مصروفات. اطلب من مالك النشاط إضافتها من الإعدادات › أنواع المصروفات.", // new
    expTypeNoneAdmin: "لا توجد أنواع مصروفات بعد: أضفها من الإعدادات › أنواع المصروفات، أو اختر حسابًا من التفاصيل المحاسبية المتقدمة.", // new
    expTypeByAccount: "– الحساب محدد أدناه –", // new
    expPaidFrom: "مدفوع من", // new
    expCashBoxes: "الصناديق", // new
    expBanks: "البنوك", // new
    expSplit: "الدفع من أكثر من مصدر", // new
    expOneSource: "الدفع من مصدر واحد", // new
    expSplitTotal: "يجب أن يكون مجموع المصادر {x}.", // new
    expRecYesPlain: "قابلة للاسترداد (ضريبة مدخلات)", // new
    expTransactionInfo: "معلومات العملية", // new
    expDetails: "تفاصيل المصروف", // new
    expName: "اسم المصروف", // new
    expNameHint: "اختياري. اسم قصير لهذا المصروف مثل \"إيجار أكتوبر\". الملاحظة تبقى منفصلة.", // new
    expCcFromType: "مأخوذ من نوع المصروف. امسحه للحفظ بدون مركز تكلفة.", // new
    expCcOptional: "اختياري. إذا تُرك فارغًا يُحفظ المصروف بدون مركز تكلفة.", // new
    expAdvanced: "تفاصيل محاسبية متقدمة", // new
    etTaxDefault: "معالجة ضريبة المصروفات الافتراضية", // new
    etTaxDefaultNone: "لم تُحدَّد", // new
    etTaxDefaultHint: "تُطبَّق على كل مصروف لا يختار له المحاسب معالجة أخرى. تغييرها لا يغيّر المصروفات المحفوظة سابقًا.", // new
    etTaxDefaultUnset: "لم تُحدَّد بعد: لن يتمكن المستخدمون من حفظ مصروف عليه ضريبة حتى تختارها. ويمكنك أنت أو المحاسب اختيار المعالجة لكل مصروف.", // new
    etTaxDefaultSaved: "تم حفظ معالجة الضريبة الافتراضية.", // new
    expTaxByDefault: "معالجة الضريبة: {x}، حسب إعداد المنشأة.", // new
    expTaxByDefaultUnset: "لم تُحدَّد بعد معالجة الضريبة الافتراضية للمصروفات. اطلب من مالك المنشأة أو المحاسب تحديدها من الإعدادات › أنواع المصروفات.", // new
    expTaxKept: "معالجة الضريبة: {x}، كما حددها المحاسب.", // new
    expRecDefault: "حسب إعداد المنشأة ({x})", // new
    expRecDefaultUnset: "اختر (لم يُحدَّد إعداد للمنشأة بعد)", // new
    fieldExpTaxDefaultMissing: "لم تُحدَّد بعد معالجة الضريبة الافتراضية للمصروفات. اطلب من مالك المنشأة أو المحاسب تحديدها من الإعدادات › أنواع المصروفات.", // new
    expTypeAccount: "هذا النوع يُرحَّل إلى {a}.", // new
    expAdvancedHint: "اختر نوع مصروف، أو حساب مصروف مباشرة.", // new
    expDirectAccount: "الترحيل إلى حساب آخر", // new
    expDirectAccountHint: "اتركه فارغًا لاستخدام حساب النوع. اختيار حساب يحل محل النوع.", // new
    errExpenseAccountNotAllowed: "اختر نوع مصروف. اختيار الحساب مباشرة يحتاج إلى مالك النشاط أو صلاحية المحاسبة المتقدمة.", // new
    errExpenseTypeChanged: "نوع هذا المصروف أصبح يُرحَّل إلى حساب آخر غير الذي كان عند الحفظ. افتحه وراجعه واحفظه مرة أخرى قبل الترحيل.", // new
    fieldExpTypeInactive: "نوع المصروف هذا غير نشط. اختر نوعًا آخر أو اطلب من مالك النشاط تفعيله.", // new
    fieldExpTypeUnmapped: "حساب نوع المصروف هذا لم يعد حساب مصروف. اطلب من مالك النشاط ربط النوع بحساب مصروف في الإعدادات › أنواع المصروفات." // new
  }
};
